<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  export default {
    data () {
      return {
        
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    watch: {

    },
    computed: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: `admin/cuti/history?user_id=${this.$route.params.id}`,

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Nomor Induk Pegawai',
              width: '200px',
              value: 'user_code',
              freeze: false,
              hide: false
            },
            {
              text: 'Nama Lengkap',
              width: '400px',
              value: 'user_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Jumlah Cuti',
              width: '200px',
              value: 'value',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal Pengajuan',
              width: '200px',
              value: 'pengajuan_date',
              freeze: false,
              hide: false,
              format: 'date'
            },
            {
              text: 'Tanggal Mulai Ijin & Cuti',
              width: '200px',
              value: 'start_date',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal Selesai Ijin & Cuti',
              width: '200px',
              value: 'end_date',
              freeze: false,
              hide: false
            },
            {
              text: 'Jam Mulai Ijin',
              width: '200px',
              value: 'start_time',
              freeze: false,
              hide: false
            },
            {
              text: 'Jam Selesai Ijin',
              width: '200px',
              value: 'end_time',
              freeze: false,
              hide: false
            },
            {
              text: 'Keterangan',
              width: '400px',
              value: 'note',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '200px',
              value: 'status',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // CONFIG PARSING FORM
          form: [],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: false,
              api: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>